import * as React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {
  starAnalyticsDashboards,
  unstarAnalyticsDashboards,
} from 'insights/analytics-dashboards/AnalyticsDashboardActions';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';
import StarIcon from 'nav/sidepanel/StarIcon';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {AnalyticsDashboardSearchAttributesGraphQL} from '../../../graphql-fragments/insights/__generated/AnalyticsDashboardSearchAttributesGraphQL';
import BaseAnalyticsListingRenderer from './BaseAnalyticsListingRenderer';

export default class AnalyticsDashboardListingRenderer extends BaseAnalyticsListingRenderer<ListingRendererType.ANALYTICS_DASHBOARD> {
  listingRendererType = ListingRendererType.ANALYTICS_DASHBOARD;
  icon: BenchlingIconName = ModelTypeConstants.ANALYTICS_DASHBOARD;

  private handleClickStar(item: AnalyticsDashboardSearchAttributesGraphQL): Promise<void> {
    return item.starred ? unstarAnalyticsDashboards([item.id]) : starAnalyticsDashboards([item.id]);
  }

  renderStarIcon(item: AnalyticsDashboardSearchAttributesGraphQL): React.ReactNode {
    return (
      <StarIcon
        onClick={() => {
          this.handleClickStar(item);
        }}
        starred={item.starred}
      />
    );
  }
}
